import React, { useState, useRef, useEffect } from "react";
import { Icon } from "semantic-ui-react";
import { ListWorkPermits } from "../../../components/Admin/WorkPermits";
import { ApprovalConfig } from "./ApprovalConfig/ApprovalConfig";
import { BasicDrawer, ManagementModuleTitle } from "../../../components/Shared";
import { useSite, useLanguage } from "../../../contexts";
import { useCompany } from "../../../contexts/CompanyContext";
import "./WorkPermits.scss";

const CURRENT_YEAR = new Date().getFullYear();
const YEAR_OPTIONS = Array.from({ length: 5 }, (_, i) => CURRENT_YEAR - 2 + i).reverse();

// const CURRENT_YEAR = new Date().getFullYear();
// const YEAR_OPTIONS = Array.from({ length: 5 }, (_, i) => CURRENT_YEAR - 2 + i).reverse();

export function WorkPermits() {
  const [reload,      setReload]      = useState(false);
  const [filterYear,  setFilterYear]  = useState(CURRENT_YEAR);
  const [showConfig,  setShowConfig]  = useState(false);
  const onReload = () => setReload((prev) => !prev);

  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;
  const { site }    = useSite();
  const { company } = useCompany();

  const hasCompany = company && company !== "0" && company !== 0;

  const [showYearMenu, setShowYearMenu] = useState(false);
  const yearMenuRef = useRef(null);

  useEffect(() => {
    if (!showYearMenu) return;
    const handler = (e) => {
      if (yearMenuRef.current && !yearMenuRef.current.contains(e.target))
        setShowYearMenu(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [showYearMenu]);

  return (
    <div className="wp-page">

      {/* ── Header ── */}
      <div className="wp-page__title-bar">
        <ManagementModuleTitle labelClassName="wp-page__title" />
      </div>

      <div className="wp-page__year-row">
        <div className="wp-page__year-bar" ref={yearMenuRef}>
          <button
            type="button"
            className="wp-page__year-bar__toggle"
            onClick={() => setShowYearMenu((v) => !v)}
          >
            <span className="wp-page__year-bar__label">{filterYear}</span>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" width="20" height="20" className={`wp-page__year-bar__arrow${showYearMenu ? " wp-page__year-bar__arrow--open" : ""}`}>
              <circle cx="12" cy="12" r="9"/>
              <path d="M12 8v6m0 0-2.5-2.5M12 14l2.5-2.5"/>
            </svg>
          </button>

          {showYearMenu && (
            <div className="wp-page__year-menu">
              {YEAR_OPTIONS.map((y) => (
                <button
                  type="button"
                  key={y}
                  className={`wp-page__year-menu__item${y === filterYear ? " wp-page__year-menu__item--active" : ""}`}
                  onClick={() => { setFilterYear(y); setShowYearMenu(false); }}
                >
                  {y}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* ── Contenido ── */}
      {hasCompany ? (
        <div className="wp-page__body">
          <ListWorkPermits
            reload={reload}
            onReload={onReload}
            filterYear={filterYear}
            onOpenConfig={() => setShowConfig(true)}
          />
        </div>
      ) : (
        <div className="wp-page__no-site">
          <Icon name="building outline" size="large" />
          <p>{t("select_company_from_header") || "Seleccioná una empresa desde el encabezado para ver los permisos de trabajo."}</p>
        </div>
      )}

      {/* ── Drawer configuración de aprobaciones ── */}
      <BasicDrawer show={showConfig} close={() => setShowConfig(false)} width="90vw" hideHeader flush>
        {showConfig && (
          <ApprovalConfig
            siteId={site}
            onBack={() => setShowConfig(false)}
          />
        )}
      </BasicDrawer>
    </div>
  );
}
